const Util = {
    countDown: function (target, end, parent) {
        if (!target || !end) {
            return false
        }
        console.log(...arguments)
        let usTime;
        let result;
        let interval = null;
        let u = navigator.userAgent, isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      	let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))

        const startTime = '2023-03-28 23:59:59';
        const endTime = '2023-03-30 15:59:59';

        if (isIOS||isSafari) {
            　　//这个是ios操作系统
            end = formatTimeStamp(end)
        }
        const timestamp = new Date(end)

        function formatTimeStamp(date){
            return Date.parse(new Date(date.replace(/-/g,'/')));
        }

        function getServerDate() {
            $.ajax({
                async: false, type: "OPTIONS", url: "/", complete: function (x) {
                    usTime = getUsTime(x.getResponseHeader("Date"))
                }
            })
        }

        function getUsTime(date) {
            let d = new Date(date);
            let timezone = 8; //目标时区时间
            let offset_GMT = d.getTimezoneOffset();
            let nowDate = d.getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
            let targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
            // console.log(targetDate)
            return targetDate
        }
        getServerDate()



        if (+usTime < +timestamp) {
            interval = setInterval(countDown, 1000)
        } else {
            $(parent).hide()
        }

        function countDown() {
            /*封装减1秒的函数*/
            if (result > 1) {
                result = result - 1;
                let second = Math.floor(result % 60);     // 计算秒 ，取余  
                let minite = Math.floor((result / 60) % 60); //计算分 ，换算有多少分，取余，余出多少秒
                let hour = Math.floor((result / 3600)); //计算小时，换算有多少小时，取余，24小时制除以24，余出多少小时
                let day = Math.floor(result / (3600 * 24));  //计算天 ，换算有多少天
                // <span style="display: ${day > 0 ? 'inline-block' : 'none'}">${day > 0 ? day : ''}d : </span>

                let tem = `
               <div>
                 <span>
                    <span class="count-num">${hour < 10 ? '0' + hour : hour}</span>
                    <span>H : </span>
                </span>
                 <span>
                    <span class="count-num">${minite < 10 ? '0' + minite : minite}</span>
                    <span>M : </span>
                </span>
                 <span>
                    <span class="count-num">${second < 10 ? '0' + second : second}</span>
                    <span>S</span>
                </span>
               </div>
           `
                $(target).html(tem)
            } else {
                debugger
                if (+usTime > +timestamp) {
                    window.clearInterval(interval);//这里可以添加倒计时结束后需要执行的事件
                    $(target).html('')
                    $(parent).hide()
                } else {
                    getServerDate()
                    result = Math.floor(+timestamp - +usTime) / 1000;
                }
            }

        }
    },
    apiPost: function (url, data, cb) {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', url, true);
        xhr.responseType = 'json'
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function (e) {
            if (xhr.readyState == 4) {
                cb(xhr.response)
            }
        };
    },

}